import { useState, useContext, useMemo, useRef, useEffect } from 'react';
import moment from 'moment';

import { LoginContext } from '../context/login-context';

import useProtectedQuery from '../hooks/use-protected-query';
import useProtectedMutation from '../hooks/use-protected-mutation';

// import VOCClient from "../VOCClient";
import RebatesClient from '../RebatesClient';
import { queryOptions } from '@tanstack/react-query';

export default function useReports(props) {
    const { state: userData } = useContext(LoginContext);


    const {
        selectedFarms,
        startDate,
        endDate
    } = props

    const {
        data: reportData,
        isLoading: reportLoading,
        error: reportError,
        refetch: reportRefetch
    } = useProtectedQuery({
        queryKey: ['get-reports',],
        queryFn: async () => {
         
            var url = `/api/report?start=${startDate.toISOString()}&end=${endDate.toISOString()}`;
            const selectedFarmIds = selectedFarms?.map(f=>f.id)
            url += selectedFarmIds?.length ? `&farm_acct_ids=${selectedFarmIds?.join(',')}` : ''

            const result = await RebatesClient.standardFetch(url)

            if (result.response.ok) {
                const report = result.body.report

                return report
            }
            else {
                throw new Error("Error getting report");
            }

        },
    });





    return {
        
        reportData,
        reportLoading,
        reportError,
        reportRefetch,
    }
}
